import { renderColorByString } from 'components/DataGrid/renderColorByString'
import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

export const StatusContainer = styled(Box)(({ type }: { type: string }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  bgcolor: renderColorByString(type),
  fontWeight: 'bold',
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  maxWidth: 145,
}))
